import { tss } from 'tss-react';
import React from 'react';
import styles from "./styles";
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";

import WebsaUITheme from '../Shared/WebsaUITheme';
import ThemeProvider from '../Shared/ThemeProvider';

import RailsForm from '../Shared/RailsForm';
import RailsRoutes from '../Shared/RailsRoutes';
import Copyright from "../Shared/Copyright/Copyright";
import LogoHeader from "../Shared/LogoHeader/LogoHeader";
import Slider from "../Shared/Slider/Slider";

export default function ResendEmail(props) {
  const theme = ThemeProvider(props.theme);
  const { classes } = tss.create(styles(theme))();

  const email = props.email;

  const formAttrs = {
    action: RailsRoutes.user_confirmation_path(),
    method: 'post',
    className: classes.tagForm
  }

  return (
    <WebsaUITheme theme={props.theme}>
      <div className={classes.root}>
        <LogoHeader/>
        <div className={classes.slider}>
          <Slider/>
        </div>
        <div className={classes.form}>
          <div className={classes.head}>
            <p>
              Sign in as a different user? <Link rel="stylesheet" data-method="DELETE" href={RailsRoutes.destroy_user_session_path()}>Sign out</Link>
            </p>
          </div>
          <RailsForm attrs={formAttrs}>
            <input type='hidden' name='user[email]' value={email} />
            <div className={classes.flexColumn}>
              <span className="ico-email_warning"/>
              <span className={classes.infoBlockTitle}>
                Check your email
              </span>
              <span className={classes.infoBlockDescription}>
                Check your email for an activation link and confirm them to keep account secure.
              </span>
              <Button variant="text" type="submit" color="primary" onClick={() => {}}>
                <span className="ico-reset"/>
                Resend email
              </Button>
              <p className={classes.infoBlockContent}>
                Problems verifying account?
                <br/>
                Contact <Link rel="stylesheet" href={`mailto:${theme.variables.supportEmail}`}>{theme.variables.supportEmail}</Link>
              </p>
            </div>
          </RailsForm>
          <Copyright/>
        </div>
      </div>
    </WebsaUITheme>
  );
}
